import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '@libs/components/icons';
import { FormatAbsolutePipe } from '@libs/shared/ui';

@Component({
  selector: 'ui-user-blocked',
  templateUrl: './user-blocked.component.html',
  styleUrls: ['./user-blocked.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormatAbsolutePipe,
    IconComponent,
  ],
})
export class UserBlockedComponent {
}
